import { render, staticRenderFns } from "./CampaignListItem.vue?vue&type=template&id=98ac378c&scoped=true"
import script from "./CampaignListItem.vue?vue&type=script&lang=js"
export * from "./CampaignListItem.vue?vue&type=script&lang=js"
import style0 from "./CampaignListItem.vue?vue&type=style&index=0&id=98ac378c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ac378c",
  null
  
)

export default component.exports